<template>
  <div class="hot-category-wrapper" id="pc__hot-category-wrapper">
    <p class="title-text">Hot Category</p>
    
    <div class="list-wrapper">
      <div
        v-for="(ctgs, ctgIdx) in previewList"
        :key="ctgIdx"
        class="cty-list"
      >
        <div
          v-for="(item, idx) in ctgs"
          :key="idx"
          :style="ctyItemStyle"
          class="inner-list"
        >
          <div
            class="cty-item"
            @click="handleHotCategoryClick(item)"
          >
            <div class="cty-icon">
              <img :src="$cvWebpFn(item.iconUrl, { w: 124 })" :alt="item.name">
            </div>
            <p class="cty-name">{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { buildCategoryNavigationSource } from '~/plugins/utils'

interface IProps {
  categoryList: ICategory[]
}
const props = defineProps<IProps>()
const { $formatStringToURL } = useNuxtApp()

const colCount = computed<number>(() => {
  const rowCount = Math.ceil(props.categoryList.length / 2)

  return rowCount > 10 ? 10 : rowCount
})

const ctyItemStyle = reactive({ width: '', minWidth: '' })
const getCtyItemWidth = (ctgs: number) => {
  const wrapperEl = document.getElementById('pc__hot-category-wrapper')
  const w = wrapperEl!.clientWidth
  const itemW = `${(w / ctgs).toFixed(2)}px`

  ctyItemStyle.width = itemW
  ctyItemStyle.minWidth = itemW
}
onMounted(async() => {
  await nextTick()
  getCtyItemWidth(colCount.value)
  window.onresize = () => {
    getCtyItemWidth(colCount.value)
  }
})

const previewList = computed<ICategory[][]>(() => {
  // if(colCount.value <= 5) {
  //   return [props.categoryList]
  // }
  
  const list1 = props.categoryList.slice(0, colCount.value)
  const list2 = props.categoryList.slice(colCount.value)

  return [list1, list2]
})
const router = useRouter()
const handleHotCategoryClick = (item: ICategory) => {
  const source = buildCategoryNavigationSource('hotCategory', item.name)
  router.push(`/category/${$formatStringToURL(item.name)}?id=${item.id}&form=category-hot&source=${encodeURIComponent(source)}`)
}
</script>

<style lang="scss" scoped>
.hot-category-wrapper{
  height: 720px;
}
// @media (max-width: 1800px) {
//   .hot-category-wrapper{
//     height: 640px;
//   }
// }
.title-text{
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
}
.list-wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  @include pc__scrollbar();
}
.cty-list{
  display: flex;
  .inner-list{
    display: flex;
    justify-content: center;
    flex-wrap: nowrap;
  }
  .cty-item{
    width: 230px;
    padding: 20px;
    transition: all .15s;
    cursor: pointer;
    border-radius: 6px;
    &:hover{
      color: var(--pc-default-color);
      box-shadow: 3px 4px 12px #DADADA;
      transform: scale(1.01);
    }
    .cty-name{
      @include ellipsisMultiline(2);
      text-align: center;
      margin-top: 20px;
    }
    .cty-icon{
      width: 100%;
      height: 0;
      overflow: hidden;
      padding-top: 100%;
      position: relative;
      img {
        width: 100%!important;
        height: auto;
        position: absolute;
        top: 0;
        left: 0;
        -o-object-fit: cover;
        object-fit: cover;
      }
    }
  }
}
</style>